import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import * as actions from './resource.actions';
import * as reducer from './resource.reducer';
import { mergeMap } from 'rxjs/operators';
import { EntityDataService, EntityDefinitionService } from 'ngrx-data';
import { CreateSuccess } from './resource.actions';

@Injectable()
export class ResourceEffects {

    constructor(
        protected http: HttpClient,
        protected actions$: Actions,
        protected store: Store<reducer.State>,
        protected entityDefinitionService: EntityDefinitionService,
        protected entityDataService: EntityDataService
    ) {

    }

    @Effect()
    createResource$: Observable<Action> = this.actions$
        .pipe(
            ofType(actions.CREATE),
            mergeMap((payload: actions.Create) => {

                // register entity
                const entityMap                = {};
                entityMap[payload.resource.id] = {};

                this.entityDefinitionService.registerMetadataMap(entityMap);

                // this.entityDataService.registerService(payload.resource.id, this.chassisDataService);

                return Observable.of(new CreateSuccess(payload.resource));
            })
        );

}


// WEBPACK FOOTER //
// ./libs/chassis-resource/src/+state/resource.effects.ts